import React from 'react';

import {
  PlatformStaffListDocument,
  useCheckDeletionClearVerifyStaffQuery,
  useDeleteClearVerifyStaffMutation,
} from 'src/api';
import { useNotification } from 'src/hooks/app';
import { DeleteConfirmationModal } from 'src/modals/common';
import { ModalV2Props } from 'src/types/modalV2';

type DeleteClearVerifyStaffConfirmationModalProps = {
  clearVerifyStaffId: string;
};

export const DeleteClearVerifyStaffConfirmationModal: React.FC<
  ModalV2Props<DeleteClearVerifyStaffConfirmationModalProps>
> = ({ id, clearVerifyStaffId }) => {
  const { createApolloContext } = useNotification();

  const { data, loading } = useCheckDeletionClearVerifyStaffQuery({
    variables: { platformStaffId: clearVerifyStaffId },
    fetchPolicy: 'network-only',
  });

  const [deleteClearVerifyStaff, { loading: deleteLoading }] = useDeleteClearVerifyStaffMutation({
    refetchQueries: [PlatformStaffListDocument],
    context: createApolloContext({ successMessage: 'Successfully deleted' }),
  });

  const handleConfirm = React.useCallback(
    () => deleteClearVerifyStaff({ variables: { platformStaffId: clearVerifyStaffId } }),
    [deleteClearVerifyStaff, clearVerifyStaffId],
  );

  return (
    <DeleteConfirmationModal
      id={id}
      entityName="Clear Verify staff"
      description="You want to delete this staff member?"
      check={data?.checkDeletionClearVerifyStaff}
      loading={loading}
      deleteLoading={deleteLoading}
      onConfirm={handleConfirm}
    />
  );
};
